export const GET_ROLES = 'roles/FETCH_DATA';
export const GET_APPLICATION_ROLES = 'application-roles/FETCH_DATA';

export const CREATE_ROLE = 'role/CREATE';
export const DELETE_ROLE = 'role/DELETE';
export const UPDATE_ROLE = 'role/UPDATE';

export const ASSIGN_ROLE = 'role/ASSIGN';
export const UN_ASSIGN_ROLE = 'role/UN_ASSIGN';

export const GET_SUBJECTS = 'role/GET_SUBJECTS';